/**
 * @generated SignedSource<<28286f3c1d98fce6e982b8cc10f50d68>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedPrintDetails_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedItemDetailsAdditionalOptions_item" | "PdpRespSharedItemDetailsDescription_item" | "PdpRespSharedItemDetailsList_item">;
  readonly " $fragmentType": "PdpRespSharedPrintDetails_item";
};
export type PdpRespSharedPrintDetails_item$key = {
  readonly " $data"?: PdpRespSharedPrintDetails_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedPrintDetails_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedPrintDetails_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedItemDetailsDescription_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedItemDetailsList_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedItemDetailsAdditionalOptions_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "1c4e169b4a52ea368974cbf74ef239ba";

export default node;
